import "./App.css";
import { Header } from "./components/Header";
import { Content } from "./components/Content";
import { Footer } from "./components/Footer";
import { Helmet } from "react-helmet";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BackToTopButton } from "./components/BackToTopButton";
import AOS from "aos";
import "./aos.css";

const theme = createTheme({
  palette: {
    black: {
      main: "black",
    },
  },
});

const pages = ["mainSection", "aboutUs", "serviceUs", "contactUs"];

function App() {
  AOS.init({
    once: true,
  });
  const langLocalstorage = localStorage.getItem("language") || "th";
  // console.log({ langLocalstorage });
  const [language, setLanguage] = useState(langLocalstorage);
  const { t, i18n } = useTranslation();
  if (!langLocalstorage) {
    setLanguage(langLocalstorage);
  }

  const changeLanguage = (lang) => {
    // console.log("Language: ", lang);
    localStorage.setItem("language", lang);
    setLanguage(lang);
  };

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("TITLE")}</title>
      </Helmet>
      <section id="mainSection"></section>
      <Header func={changeLanguage} translate={t} pages={pages} />
      <Content translate={t} />
      <Footer translate={t} />
      <BackToTopButton />
    </ThemeProvider>
  );
}

export default App;
